import {createClient} from '@supabase/supabase-js'
import {type Database} from './tables.generated'
import {envServer} from '../../api/server/envServer'

export const sbServer =
  envServer.SUPABASE_SERVICE_KEY ?
    createClient<Database>(
      envServer.SUPABASE_URL ?? envServer.NEXT_PUBLIC_SUPABASE_URL,
      envServer.SUPABASE_SERVICE_KEY,
      {}
    )
  : undefined

export const getSbServer = () => {
  if (sbServer == null) throw new Error('serverSb should exist on server')
  return sbServer
}
